/*
 * @Author: jackshen
 * @Date: 2021-07-08 09:33:09
 * @LastEditors: wenlin
 * @LastEditTime: 2021-07-08 18:35:22
 * @Description:
 */
import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    logined: false,
    caseMenus: []
  },
  mutations: {
    setLoginState (state, s) {
      state.logined = s
    },
    setCaseMenus (state, menus) {
      state.caseMenus = menus
    }
  },
  actions: {
    login (context) {
      return new Promise(resolve => {
        axios.get(`${process.env.VUE_APP_DATA_URL}/auth/url`).then(({data}) => {
          resolve(data)
        })
      })
    },
    logined (context) {
      return new Promise(resolve => {
        axios({method: 'get', url: `${process.env.VUE_APP_DATA_URL}/auth/logined`, withCredentials: true}).then(({data}) => {
          resolve(data)
        })
      })
    },
    set_menu (context, str) {
      // console.log(str,111)
      context.commit('setCaseMenus', str)
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js